var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};

site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);

		$owl.each(function() {
			var $this = $(this);
			if ($this.length > 0 && $this.children().length > 1) {
				$this.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
				$this.owlCarousel(options);
			}
		});

	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};

site.houses = {
	init: function() {
		site.houses.initFilter();

		site.owl.init('#houses .images', {
			items: 1,
			navText:'',
			nav:true,
			dots:false,
			mouseDrag:false,
			touchDrag:false,
			pullDrag:false
		});
	},

	initFilter: function() {
		var $grid = $('#houses .items').isotope({
			itemSelector: '.item',
			layoutMode: 'fitRows'
		}),

		activeFilters = [],

		getActiveFilters = function() {
			return activeFilters.join(', ');
		},
		addActiveFilter = function(filter) {
			activeFilters.push(filter);
		},
		removeActiveFilter = function(filter) {
			activeFilters = activeFilters.filter(function(e) { return e !== filter })
		};

		// layout Isotope after each image loads
		$grid.imagesLoaded().progress( function() {
			$grid.isotope('layout');
		});

		$('.buttons').on( 'click', 'button', function() {
			var $this = $(this);
			var filterValue = $this.attr('data-filter');
			if ($this.hasClass('selected') && !$this.hasClass('lowest')) {
				$this.siblings().removeClass('lowest');
				$this.addClass('selected lowest');
				$this.prevAll().each(function() {
					$(this).removeClass('selected');
					removeActiveFilter($(this).attr('data-filter'));
				});
			}
			else if (!$this.hasClass('lowest')) {
				$this.siblings().removeClass('lowest');
				$this.addClass('selected lowest');
				addActiveFilter(filterValue);
				$this.nextAll().each(function() {
					$(this).addClass('selected');
					addActiveFilter($(this).attr('data-filter'));
				});
			}
			else if ($this.hasClass('lowest')) {
				$this.removeClass('lowest');
				$this.parent().children().each(function() {
					$(this).removeClass('selected');
					removeActiveFilter($(this).attr('data-filter'));
				});
			}
			$this.blur();
			$grid.isotope({ filter: getActiveFilters() });
		});

		$('select', '.selectFilter').on('focus', function () {
			removeActiveFilter(this.value);
		}).change(function() {
			addActiveFilter(this.value);
			$grid.isotope({ filter: getActiveFilters() });
			$(this).blur();
		});

	}
};

site.employees = {
	init: function () {
		if ($('#employees .staff').length === 0) {
			return false;
		}

		//site.maxHeight.init('.employee .content');

		$('button.empExpand').on('click', function(e) {
			e.stopPropagation();
			var $this = $(this),
				$employee = $this.closest('.employee');
			$employee.siblings().removeClass('showContent');
			$employee.toggleClass('showContent');
			$(this).find('i.fas').toggleClass('hideOpacity');
		});

		$('.content', '.employee').on('click', function(e) {
			e.stopPropagation();
		});

		$('body').on('click', function() {
			$('.employee', '.staff').removeClass('showContent');
		});
	}
};

site.house = {
	view: function () {
		var $others = $('.box_other');
		$others.responsiveDom({
			appendTo: '#below .otherMobile',
			mediaQuery: 'screen and (max-width: 991px)',
		});
	}
};

site.frontpage = {
	init: function() {
		//site.frontpage.newsCarousel();
		$(window).resize(function() {
			//site.frontpage.newsCarousel();
		});
	},

	hasCarousel: false,

	newsCarousel: function() {
		var $body = $('body');
		if ($body.width() < 992) {

			if (!site.frontpage.hasCarousel) {
				site.owl.init('.news__entries', {
					responsive: {
						0: {
							items: 1
						},
						480: {
							items: 2
						}
					}
				});
				site.frontpage.hasCarousel = true;
			}
		}
		else {
			if (site.frontpage.hasCarousel) {
				$('.news__entries').owlCarousel('destroy').removeClass('owl-carousel');
				site.frontpage.hasCarousel = false;
			}
		}
	}
};


// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();
	site.megamenu.init();
	site.employees.init();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
